<template>
  <div class="non-vigent-chapters-container">
    <h2>Capítulos No Vigentes</h2>
    <DataTable
      :value="chapters"
      :loading="isLoading"
      :paginator="true"
      :rows="10"
      :rowsPerPageOptions="[5, 10, 20]"
      responsiveLayout="scroll"
      class="p-datatable-sm"
    >
      <template #empty>
        No se encontraron capítulos no vigentes.
      </template>
      <template #loading>
        Cargando capítulos no vigentes...
      </template>
      <Column field="IdCapitulo" header="ID Capítulo" sortable />
      <Column field="Glosa" header="Nombre" sortable />
      <Column field="IdCurso" header="ID Curso" sortable />
      <Column field="IdAsignatura" header="ID Asignatura" sortable />
      <Column field="IdUnidad" header="ID Unidad" sortable />
      <Column header="Acciones">
        <template #body="slotProps">
          <ButtonPrime
            label="Activar"
            icon="pi pi-check-circle"
            class="p-button-success p-button-sm"
            @click="activateChapter(slotProps.data.IdCapitulo)"
            :loading="activatingChapter === slotProps.data.IdCapitulo"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import MatrizService from '@/services/MatrizService';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonPrime from 'primevue/button';

export default {
  name: 'NonVigentChapters',
  components: {
    DataTable,
    Column,
    ButtonPrime
  },
  props: {
    usuarioId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      chapters: [],
      isLoading: false,
      activatingChapter: null // ID del capítulo que se está activando
    };
  },
  methods: {
    async fetchNonVigentChapters() {
      console.log('Obteniendo capítulos no vigentes...');
      this.isLoading = true;

      try {
        const response = await MatrizService.getNonVigentChapters();
        console.log('Respuesta del backend (capítulos no vigentes):', response);

        if (response.Message.includes("Capítulos no vigentes obtenidos")) {
          this.chapters = response.Chapters;
          this.$emit('chapters-loaded', this.chapters.length);
        } else {
          this.$emit('chapters-error', 'Respuesta inesperada del servidor');
        }
      } catch (error) {
        console.error('Error al obtener capítulos no vigentes:', error);
        const errorMsg = error.response?.data?.Message || error.response?.data || 'Error desconocido al cargar capítulos';
        this.$emit('chapters-error', errorMsg);
      } finally {
        this.isLoading = false;
      }
    },

    async activateChapter(idCapitulo) {
      console.log('Activando capítulo:', idCapitulo);
      this.activatingChapter = idCapitulo;

      try {
        const payload = {
          IdCapitulo: idCapitulo,
          UsuarioId: this.usuarioId,
          Vigente: 1
        };

        const response = await MatrizService.toggleChapterVigencia(payload);
        console.log('Respuesta del backend (activar capítulo):', response);

        if (response.Message.includes("Vigencia actualizada")) {
          // Remover el capítulo de la lista al activarlo
          this.chapters = this.chapters.filter(chapter => chapter.IdCapitulo !== idCapitulo);
          this.$emit('chapter-activated', { idCapitulo, message: response.Message });
        } else {
          this.$emit('chapter-error', 'Respuesta inesperada del servidor al activar');
        }
      } catch (error) {
        console.error('Error al activar capítulo:', error);
        const errorMsg = error.response?.data?.Message || error.response?.data || 'Error desconocido al activar capítulo';
        this.$emit('chapter-error', errorMsg);
      } finally {
        this.activatingChapter = null;
      }
    }
  },
  mounted() {
    this.fetchNonVigentChapters(); // Cargar los capítulos al montar el componente
  }
};
</script>

<style scoped>
.non-vigent-chapters-container {
  padding: 20px;
}

h2 {
  margin-bottom: 20px;
  color: #333;
}

.p-datatable-sm {
  font-size: 0.9rem;
}

.p-button-sm {
  padding: 0.5rem 1rem;
}
</style>